export default __webpack_public_path__ + "locales/bg/Profile.json?hash=788db10e481e83b7d059aa17bf960c45";